import { useKnopClient } from "@opstel/contexts/knopClient/useKnopClient";
import { instances } from "@opstel/query/queryKeys/instanceKeys";
import { Werklijnen } from "@personeel/components/Werklijnen/Werklijnen.tsx";
import {
  useFetchKlussenOverview,
  useFetchPersoneelsdiensten,
} from "@personeel/hooks/useFetchData.ts";
import { usePersoneelsinstellingen } from "../../hooks/usePersoneelsinstellingen.ts";
import { usePersoneelsdienstenStore } from "@personeel/stores/PersoneelsdienstenStore.ts";
import { EmptyState } from "@shared/common/components/State/EmptyState";
import { ErrorState } from "@shared/common/components/State/ErrorState";
import { LoadingState } from "@shared/common/components/State/LoadingState";
import { useCurrentInstanceId } from "@shared/common/contexts/instanceMetadata/useInstanceId";
import { useKnopIsLoading } from "@shared/common/hooks/useKnopIsLoading";
import { useLocalStorageManager } from "@shared/common/hooks/useLocalStorageManager";
import { useQueries } from "@tanstack/react-query";
import React from "react";

export function WerklijnenWrapper(): React.JSX.Element {
  const isLoading = useKnopIsLoading((state) => state.isLoading);
  const { knopClient } = useKnopClient();
  const { prepareStore } = useLocalStorageManager();
  const { instanceId } = useCurrentInstanceId();

  // Haal personeelsinstellingen op en update de store
  usePersoneelsinstellingen();

  const fetchQueries = [
    {
      name: "fetchKlussenOverview",
      ...useFetchKlussenOverview(),
    },
    {
      name: "fetchPersoneelsdiensten",
      ...useFetchPersoneelsdiensten(),
    },
  ];

  const queries = useQueries({
    queries: [
      {
        queryKey: instances.current(instanceId).scenario,
        queryFn: () => knopClient.getScenario(instanceId),
      },
    ],
  });

  const personeelsdiensten = usePersoneelsdienstenStore((state) => state.personeelsdiensten);

  if (isLoading || queries.some((q) => q.isLoading) || fetchQueries.some((q) => q.isLoading))
    return (
      <div data-testid="state-werklijnen-loading">
        <LoadingState fullPage={false} />
      </div>
    );
  if (queries.some((q) => q.isError)) {
    for (const q of queries.filter((q) => q.isError)) {
      console.log(q.error);
    }
    return (
      <div data-testid="state-werklijnen-error">
        <ErrorState />
      </div>
    );
  }
  const [{ data: scenario }] = queries;

  if (!scenario)
    return (
      <div data-testid="state-werklijnen-empty">
        <EmptyState />
      </div>
    );
  if (queries.every((q) => !q.isFetching)) prepareStore(scenario);

  if (personeelsdiensten.length === 0)
    return (
      <div data-testid="state-werklijnen-error">
        <ErrorState />
      </div>
    );

  return (
    <div data-testid="state-werklijnen-ready" className="h-full">
      <Werklijnen />
    </div>
  );
}
